import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { highlightKeys } from './highlightKeys';
import { IHighlightResponse } from './useQueryHighlights';

export interface IUpdateHighlightParams {
  id: number;
  title: string;
  description: string;
}

export const updateHighlight = async (
  params: IUpdateHighlightParams
): Promise<IHighlightResponse> => {
  const { id, ...body } = params;
  const response = await EXPRESS_API.put(`/highlights/${id}`, body);
  return response.data;
};

export const useUpdateHighlightMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(updateHighlight, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(highlightKeys.all());
      onSuccess?.();
      successToast({
        title: `Highlight has been successfully updated!`,
      });
    },
    onError: error =>
      showError(
        error || `An error occurred while trying to update the highlight.`
      ),
  });
};
